var _rect, _circle, _rect2, _rect3, _rect4, _path, _rect5, _circle2, _circle3, _rect6, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopilot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 3,
    width: 2.2,
    height: 6.5,
    rx: 1.1,
    fill: "#123051"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 3.2,
    r: 2.6,
    fill: "#FF6E1D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 15,
    width: 4,
    height: 9,
    rx: 2,
    fill: "#2E7FE0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28.5,
    y: 15,
    width: 4,
    height: 9,
    rx: 2,
    fill: "#2E7FE0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8.5,
    width: 24,
    height: 20.5,
    rx: 7.5,
    fill: "#6EBAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21.5C6 21.5 11 26.5 18 26.5C25 26.5 30 21.5 30 21.5V22C30 25.87 26.87 29 23 29H13C9.13 29 6 25.87 6 22V21.5Z",
    fill: "#3A9BF0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 12.5,
    width: 17,
    height: 11.5,
    rx: 4.5,
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 17.6,
    r: 2.1,
    fill: "#123051"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 17.6,
    r: 2.1,
    fill: "#123051"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 20.6,
    width: 7,
    height: 2.2,
    rx: 1.1,
    fill: "#123051"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 8.5L30.6 11L33.2 12.1L30.6 13.2L29.5 15.7L28.4 13.2L25.8 12.1L28.4 11L29.5 8.5Z",
    fill: "#FFD92E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopilot);
export default __webpack_public_path__ + "static/media/Copilot.0e75fb9d0084480301fcfb9baf06d7d6.svg";
export { ForwardRef as ReactComponent };